import { render } from "./InfoCreditoDaGestireBusiness.vue?vue&type=template&id=c9304ce6&scoped=true"
import script from "./InfoCreditoDaGestireBusiness.vue?vue&type=script&lang=js"
export * from "./InfoCreditoDaGestireBusiness.vue?vue&type=script&lang=js"

import "./InfoCreditoDaGestireBusiness.vue?vue&type=style&index=0&id=c9304ce6&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9304ce6"]])

export default __exports__